import CloseIcon from '@mui/icons-material/Close'
import { Dialog, DialogContent, DialogTitle, DialogActions } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { Button } from 'monday-ui-react-core'

const AccountCreationSuccess = ({open, onClose, email, organization}) => {
    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth={false}
                maxWidth='md'
            >
                <DialogTitle>Congratulations!</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <section className='mb-3'>
                        <span>You have successfully created an organization and user account.</span><br/><br/>
                        <span className='mt-1'><strong>Organization:</strong> {organization}</span><br/>
                        <span className='mt-1'><strong>User:</strong> {email}</span><br/><br/>
                        <span>
                            Please continue to the sign-in page and sign in using the temporary password that has been sent to your email address. 
                            <br/><br/>
                            Once you have signed in, you can add additional users to the organization using the Organizations link in the user menu located on the upper right corner of the webpage.
                        </span>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button className="success" onClick={onClose} marginRight={2} >Go to Login Page</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default AccountCreationSuccess